import { ReactElement } from 'react';
import VenueDetailsFields from 'src/components/VenueDetailsFields';
import { IVenueFormDetailsProps } from 'src/types/venueForm.types';

const VenueFormDetails = ({ formFields }: IVenueFormDetailsProps): ReactElement => {
  const {
    register,
    control,
    formState: { errors },
  } = formFields;

  return <VenueDetailsFields register={register} control={control} errors={errors} />;
};

export default VenueFormDetails;
